import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { leaderboardKeys } from './leaderboard-keys';
import useGetUserAddress from 'src/hooks/useGetUserAddress';

export interface Participant {
  rank: number;
  user_id: string;
  wallet_address: string;
  account_equity: number;
  volume: number;
  pnl: number;
  roi: number;
  points: number;
  tier: string;
}

export interface UserStats {
  account_equity: number;
  pnl: number;
  points: number;
  rank: number;
  roi: number;
  tier: string;
  user_id: string;
  volume: number;
  wallet_address: string;
}

export interface CurrentLeaderboardResponse {
  start_date: string;
  end_date: string;
  participants: Participant[];
  total: number;
  page_size: number;
  page_number: number;
  user?: UserStats;
}
export interface GetLeaderboardParams {
  page: number;
  page_size: number;
  sort_by?: string;
  sort_order?: 'desc' | 'asc';
  useraddress?: string;
}
export const getCurrentLeaderboard = async (params: GetLeaderboardParams) => {
  const response = await apiClient.get<CurrentLeaderboardResponse>('/v1/public/user-leaderboard', {
    params,
  });

  return response.data;
};

export type UseGetAvailableBalanceLPOptions<TData, TError> = QueryOptions<
  CurrentLeaderboardResponse,
  TError,
  CurrentLeaderboardResponse,
  ReturnType<typeof leaderboardKeys.getCurrentLeaderboard>
>;

export const useGetCurrentLeaderboard = <TData = CurrentLeaderboardResponse, TError = Error>(
  params: GetLeaderboardParams,
  options?: UseGetAvailableBalanceLPOptions<TData, TError>,
) => {
  const { address: walletAddress } = useGetUserAddress();

  return useQuery({
    queryKey: leaderboardKeys.getCurrentLeaderboard({
      ...params,
      useraddress: walletAddress,
    }),
    queryFn: () =>
      getCurrentLeaderboard({
        ...params,
        useraddress: walletAddress,
      }),
    enabled: true,
    ...options,
  });
};
